export const firebase_config = {
    apiKey: "AIzaSyDEJdrBgI9InD1XZ8bjomiwSwoZKxXUhAI",
    authDomain: "magisteriowebbappbackend.firebaseapp.com",
    databaseURL: "https://magisteriowebbappbackend-default-rtdb.firebaseio.com",
    projectId: "magisteriowebbappbackend",
    storageBucket: "magisteriowebbappbackend.appspot.com",
    messagingSenderId: "1078061487446",
    appId: "1:1078061487446:web:841f5d8b9f139c7074f2f7",
    measurementId: "G-1JLGVYL3DE",
}

export const EMAILJS_USER = "user_81XfS6tFoEHx9h1aYNoEY"
export const EMAILJS_TOKEN = "24db1d6e95280337d3b0062694459775"

export const BRANCH_NAME = "San José"
export const BRANCH_URL = "https://reservasfunerariadelmagisterio.web.app"

export default firebase_config
